var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-shell"},[_c('app-header',{attrs:{"user":_vm.user}}),_c('main',{staticClass:"app-main"},[_c('router-view',{attrs:{"user":_vm.user}})],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }